<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';

export interface GrammarCheckboxProps {
  formAssociated?: boolean;
  name?: string;
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  indeterminate?: boolean;
}

const props = withDefaults(defineProps<GrammarCheckboxProps>(), {
  formAssociated: true,
  name: '',
  label: '',
  disabled: false,
  checked: false,
  indeterminate: false,
});

const emit = defineEmits(['change', 'update:value']);

function onChange(event: TpgChangeEvent<boolean>) {
  emit('change', event.value);

  emit('update:value', event.value);
}
</script>

<template>
  <tpg-checkbox v-bind="props" @tpg-change="onChange" />
</template>
